<template>
    <div class="gnss_root_div">
        <div class="page-header header1">
            <div class="bluebar head_logo"></div>
            <div>{{$t("message")["HealthHome.position"]}}&nbsp;&nbsp;&nbsp;&nbsp;{{ data_date }}</div>
            <a-date-picker id="date_picker" @change="ChangeDataDate"></a-date-picker>
        </div>
        <div id="healthyMap"></div>
    </div>
</template>

<script>
import domain from "../../domain";
import request from "../../utils/request";

export default {
    data() {
        return {
            amap: null,
            data_date:"",
            deviceid:"",
            first: true,
            tracklist:[]
        }
    },
    methods: {
        getTrackOfDay(deviceid,data_date){
            if(!this.amap){
                var map = new BMapGL.Map("healthyMap");
                this.amap = map;
                var zoomCtrl = new BMapGL.ZoomControl();
                this.amap.addControl(zoomCtrl);
            }

            let reqParams = {
                deviceid: deviceid,
                record_date: data_date
            };
            let reqUrl = domain.URLS.gnssWholeDayListUrl;
            let that = this;

            request({
                url: reqUrl,
                methods: "GET",
                params: reqParams
            }).then(function(response) {
                if (response != null) {
                    that.amap.clearLabels();
                    that.amap.clearOverlays();
                    that.amap.clearSpots();
                    if (response.data.ReturnCode == 0) {
                        that.tracklist=response.data.Data;
                        that.showTracks(response.data.Data);
                    } else{
                        var myGeo = new BMapGL.Geocoder();
                        myGeo.getPoint('深圳市福田区', function(point){
                            if(point){
                                that.amap.centerAndZoom(point, 14);
                            }else{
                                alert('您选择的地址没有解析到结果！');
                            }
                        }, '深圳市')
                    }
                }
            });
        },
        showTracks(trackList){
            console.log('tracklist:',trackList);
            var pointArr = [];
            var total = 0
            var convertor = new BMapGL.Convertor();
            for(var i=0;i<trackList.length;i++){
                var gnss = trackList[i];
                var original = new BMapGL.Point(gnss.lng, gnss.lat);
                pointArr.push(original);
                total+=1;
                if(total>5){
                    if(i==trackList.length-1){
                        this.first = false;
                    }
                    convertor.translate(pointArr, COORDINATES_WGS84, COORDINATES_BD09, this.translateCallback);
                    pointArr=[];
                    total=0;
                }
            }
            if(total<=5 && pointArr.length>0){
                this.first = false;
                convertor.translate(pointArr, COORDINATES_WGS84, COORDINATES_BD09, this.translateCallback);
            }
        },
        translateCallback(data){
            console.log('translateCallback:',data);
            if(data.status != 0){
                return;
            }
            let center = Math.floor(data.points.length/2);
            for(let i=0;i<data.points.length;i++){
                let point = data.points[i];
                if(i==center && this.first==false){
                    this.amap.centerAndZoom(point, 14);
                }
                var myIcon = new BMapGL.Icon("http://api8.iwown.com/dist/snapshot/marker.png", new BMapGL.Size(14, 18),{
                anchor: new BMapGL.Size(7, 9)
                });
                if(i==0 || i==data.points.length-1 || i==center){
                    let marker = new BMapGL.Marker(point);
                    marker.setIcon(myIcon);
                    this.amap.addOverlay(marker);
                    var label = new BMapGL.Label(this.tracklist[i].time.substring(11), {  
                        position: point,                         
                        offset: new BMapGL.Size(10, 10)
                    });
                    this.amap.addOverlay(label);
                    label.setStyle({ 
                        color: '#2284FF',
                        fontSize: '12px',
                        border: '1px solid #2284FF',
                        borderRadius: '5px'
                    })
                }
            }
            var polyline = new BMapGL.Polyline(data.points
            , {strokeColor:"blue", strokeWeight:3, strokeOpacity:0.5});
            this.amap.addOverlay(polyline);
            this.first = true;
        },

        ChangeDataDate(val){
            let date_str = val.format('YYYY-MM-DD');
            this.data_date = date_str;
            this.getTrackOfDay(this.deviceid,this.data_date);
        }
    },
    mounted: function() {
        this.device_type = sessionStorage.getItem("device_type");
        this.deviceid = sessionStorage.getItem("deviceid");
        if(this.device_type==2){
            this.uid = sessionStorage.getItem("uid");
        }

        this.data_date = this.$route.params.data_date;
        this.getTrackOfDay(this.deviceid,this.data_date);
    }
}
</script>

<style scoped lang="scss">
@import "../style/GlobalStyle.scss";
.gnss_root_div {
    padding-bottom: 10px;
    position: relative;
    left: 0px;
    border: 1px solid white;
}

.page-header {
    height: 50px;
    font-size: 16px;
    color: #292929;
    letter-spacing: 0;
    line-height: 30px;
    font-weight: bold;
    padding-left: 15px;
    padding-right: 15px;
    display: flex;
    align-items: center;
}

.header1 {
    justify-content: space-around;
}

.bluebar {
    width: 4px;
    height: 13px;
    background-color: #2284FF;
}

.head_logo {
    margin-right: 10px;
}

#date_picker {
    margin-left: auto;
}

#healthyMap{
    margin-top: 50px;
    height: 500px;
    margin-left: 15px;
    margin-right: 15px;
}
</style>